import { takeLatest } from "redux-saga/effects";
import { GetHealthScreeningList } from "../../StateManagement/Reducers/HealthProfileState";
import { HealthScreeningLists } from "./HealthScreeningSagaWorkers";

export function* HealthScreeningListSaga() {
  yield takeLatest(GetHealthScreeningList.type, HealthScreeningLists);
}
